
const AwardsTimeline = () => {
  const awards = [
    {
      year: '2024',
      title: '国际茶叶博览会金奖',
      description: '马帮瑞贡古树普洱茶荣获国际茶叶博览会金奖，品质获得国际认可',
      icon: 'ri-trophy-line',
      category: '国际荣誉'
    },
    {
      year: '2023',
      title: '上海合作组织国宾伴手礼',
      description: '被选为上海合作组织官方指定国宾伴手礼，代表中国茶文化',
      icon: 'ri-gift-line',
      category: '国家荣誉'
    },
    {
      year: '2023',
      title: '云南省著名商标',
      description: '马帮瑞贡商标被认定为云南省著名商标，品牌价值获得认可',
      icon: 'ri-award-line',
      category: '品牌荣誉'
    },
    {
      year: '2022',
      title: '中华老字号认定',
      description: '马帮瑞贡品牌获得中华老字号认定，传承价值得到官方确认',
      icon: 'ri-ancient-pavilion-line',
      category: '传承荣誉'
    },
    {
      year: '2021',
      title: '绿色食品认证',
      description: '全线产品通过绿色食品认证，环保健康理念得到权威认可',
      icon: 'ri-leaf-line',
      category: '质量认证'
    },
    {
      year: '2020',
      title: '非遗制茶技艺传承人',
      description: '第五代传承人被认定为非物质文化遗产制茶技艺传承人',
      icon: 'ri-user-star-line',
      category: '技艺传承'
    }
  ];

  return (
    <section className="py-12 lg:py-16 bg-gray-50">
      <div className="px-6 lg:px-16">
        <div className="text-center mb-8 lg:mb-12">
          <h2 className="text-2xl lg:text-3xl font-bold text-primary font-serif mb-3">
            荣誉历程
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            记录马帮瑞贡获得的每一项荣誉，见证品牌成长与品质提升的足迹
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Timeline Line */}
            <div className="absolute left-6 lg:left-1/2 lg:transform lg:-translate-x-0.5 top-0 bottom-0 w-0.5 bg-accent"></div>
            
            {awards.map((award, index) => (
              <div
                key={index}
                className={`relative flex items-center mb-8 lg:mb-12 ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                {/* Timeline Dot */}
                <div className="absolute left-4 lg:left-1/2 lg:transform lg:-translate-x-1/2 w-4 h-4 bg-accent rounded-full border-4 border-white shadow-lg z-10"></div>
                
                {/* Content Card */}
                <div className={`ml-12 lg:ml-0 lg:w-1/2 ${index % 2 === 0 ? 'lg:pr-8' : 'lg:pl-8'}`}>
                  <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100">
                    <div className="flex items-center justify-between mb-3">
                      <div className="text-2xl font-bold text-accent font-serif">
                        {award.year}
                      </div>
                      <div className="flex items-center space-x-2">
                        <div className="w-8 h-8 bg-accent/10 rounded-full flex items-center justify-center">
                          <i className={`${award.icon} text-sm text-accent`}></i>
                        </div>
                        <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-full">
                          {award.category}
                        </span>
                      </div>
                    </div>
                    
                    <h3 className="text-lg font-bold text-primary font-serif mb-2">
                      {award.title}
                    </h3>
                    
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {award.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AwardsTimeline;
